import { styled } from "theme/default/styled";

import { Input } from "../Input/Input.component";

export const SForgotPasswordFormEmail = styled(Input)`
  margin-top: 20px;
  margin-bottom: 5px;
`;
